/* eslint-disable import/no-anonymous-default-export */
import siteConfig from "../siteConfig";

export default {
  path: "/reviews-content",
  shortTitle: "Reviews + content",
  title: "Reviews, messages and user content",
  category: "Data and website",
  summary: "Rules for material sent to customer care and a future review feature that does not currently exist.",
  updated: "26 October 2026",
  sections: [
    {
      heading: "Current feature boundary",
      body: [
        `The present project has no form for publishing customer reviews, ratings, photographs or social posts. Product numbers, material notes and editorial cards are store content, not customer testimonials. ${siteConfig.brandName} will not invent endorsements or present private support messages as public reviews.`,
      ],
    },
    {
      heading: "Content sent for support",
      body: [
        "A customer may email photographs or descriptions to explain damage, fit, colour, safety or delivery. They should send only content they created or are authorised to share, avoid faces and personal documents unless strictly necessary, and remove card details and unrelated private information.",
      ],
    },
    {
      heading: "Permission and moderation",
      body: [
        "Support content is used to investigate the request. It is not licensed for advertising merely because it was emailed. Separate clear permission would be required before public use, including the intended channel and any name attribution. Unlawful, threatening, infringing, deceptive or privacy-invasive material may be declined or preserved only as needed to address abuse or legal obligations.",
      ],
    },
    {
      heading: "Corrections and future changes",
      body: [
        "If a review feature is added later, this policy, privacy notice, moderation process and data retention must be revised before launch. A person who believes their authorised public content is inaccurate, attributed wrongly or used beyond permission should identify the content and requested correction to customer care. Legal rights concerning personal data, copyright and misleading endorsements remain unaffected.",
      ],
    },
  ],
};
